
































































































import Component from "vue-class-component";
import Vue from "vue";
import moduleStore from "./store/index";
import { Toast } from "vant";
import {} from 'lodash-es'
@Component({
  components: {},
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class indexPage extends Vue {
  info: any = {};
  submitId;
  mounted() {
    const info: any = this.$route.query.info;
    if (info) this.info = JSON.parse(info);
    this.submitId = this.$route.query.submitId;
    this.getDetail();
  }
  async getDetail() {
    const res = await this.$http("getInvoiceDetail", {
      submitId: this.submitId,
    });
  }
  get orderNums() {
    return eval(
      this.pageState.invoiceDetail
        .map((vo) => (vo?.transactions ? vo.transactions.length : 0))
        .join("+")
    );
  }
  goDetail() {
    this.$router.push(`/order/invoicDetail2?submitId=${this.submitId}`);
  }
  reInvoicing() {
    Toast("请联系客服重开发票");
  }
  reissue() {
    const invoiceDetail = this.pageState.invoiceDetail
    if(invoiceDetail && invoiceDetail.filter(vo=> vo.status==2).length != invoiceDetail.length){
      Toast("当前存在开票中状态的发票，不可重发发票，请在所有发票开票完成后重试！");
      return 
    }
    this.$router.push(`/order/invoicReissue?submitId=${this.submitId}&info=${JSON.stringify(this.info)}`);
  }
}
